import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Checkbox,
  FormControlLabel,
  Box,
  Divider
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";

function ItinerarySettings({ value, onChange }) {
  // Toggle nested checkbox values using string path
  const handleToggle = (path) => {
    const newState = { ...value };
    let pointer = newState;

    const keys = path.split(".");
    const lastKey = keys.pop();

    keys.forEach((key) => {
      pointer[key] = { ...pointer[key] };
      pointer = pointer[key];
    });

    pointer[lastKey] = !pointer[lastKey];
    onChange(newState);
  };
  const handleColorSelect = (selectedColor) => {
    const newColors = Object.fromEntries(
      Object.keys(value.colors).map((c) => [c, c === selectedColor])
    );

    onChange({
      ...value,
      colors: newColors
    });
  };


  // Generic checkbox generator
  const renderCheckboxList = (basePath, items) =>
    items.map((item) => (
      <FormControlLabel
        key={item.key}
        control={
          <Checkbox
            checked={item.value}
            onChange={() => handleToggle(`${basePath}.${item.key}`)}
          />
        }
        label={item.label}
      />
    ));

  return (
 
      <AccordionDetails>
        {/* Color Format */}
        <Typography sx={{ fontSize: 14, fontWeight: "bold", mt: 0, pt: 0 }}>Select your color format</Typography>
        <Box sx={{ display: "flex",flexWrap:"wrap", gap: 1, my: 0 }}>
          {Object.keys(value.colors).map((color) => (
            <FormControlLabel
              key={color}
              control={
                <Checkbox
                  checked={value.colors[color]}
                  onChange={() => handleColorSelect(color)}
                />
              }
              label={color}
            />
          ))}
        </Box>
        <Divider sx={{ my: 2 }} />

        {/* Section 1 */}
        <Typography sx={{ fontSize: 16, fontWeight: "bold" }}>PASSENGER DETAILS</Typography>
        {renderCheckboxList("section1", [
          { key: "passengerType", label: "Passenger Type", value: value.section1.passengerType },
          { key: "passengerName", label: "Passenger Name", value: value.section1.passengerName },
          { key: "loyaltyProgram", label: "Loyalty Program", value: value.section1.loyaltyProgram },
          { key: "disabilities", label: "Disabilities", value: value.section1.disabilities },
          { key: "ticketNumber", label: "Electronic Ticket Number", value: value.section1.ticketNumber }
        ])}

        <Divider sx={{ my: 2 }} />

        {/* Section 2 */}
        <Typography sx={{ fontSize: 16, fontWeight: "bold" }}>BOOKING DETAILS</Typography>

        {renderCheckboxList("section2", [
          { key: "agencyName", label: "Agency Name", value: value.section2.agencyName },
          { key: "agencyNumber", label: "Agency Number", value: value.section2.agencyNumber },
          { key: "agencyReference", label: "Agency Reference", value: value.section2.agencyReference },
          { key: "checkinReference", label: "Check-in Reference", value: value.section2.checkinReference }
        ])}

        <Divider sx={{ my: 2 }} />

        {/* Section 3 */}

        <Typography sx={{ fontSize: 16, fontWeight: "bold" }}>FLIGHT DETAILS</Typography>

        {renderCheckboxList("section3", [
          { key: "airlineName", label: "Airline Name", value: value.section3.airlineName },
          { key: "departure", label: "Departure Details", value: value.section3.departure },
          { key: "departureTime", label: "Departure Date Time", value: value.section3.departureTime },
          { key: "arrival", label: "Arrival Details", value: value.section3.arrival },
          { key: "arrivalTime", label: "Arrival Date Time", value: value.section3.arrivalTime },
          { key: "aircraft", label: "Aircraft", value: value.section3.aircraft },
          { key: "stop", label: "Stop", value: value.section3.stop },
          { key: "duration", label: "Duration", value: value.section3.duration },
          { key: "terminal", label: "Terminal", value: value.section3.terminal },
          { key: "operatedBy", label: "Operated By", value: value.section3.operatedBy },
          { key: "status", label: "Status", value: value.section3.status },
          { key: "cabin", label: "Cabin", value: value.section3.cabin },
          { key: "bookingClass", label: "Booking Class", value: value.section3.bookingClass },
          { key: "inFlightServices", label: "In-Flight Services", value: value.section3.inFlightServices }
        ])}

        <Divider sx={{ my: 2 }} />

        {/* Section 4 */}
        <Typography sx={{ fontSize: 16, fontWeight: "bold" }}>PASSENGER OTHER DETAILS</Typography>

        {renderCheckboxList("section4", [
          { key: "paxName", label: "Pax Name", value: value.section4.paxName },
          { key: "origin", label: "Origin/Destination", value: value.section4.origin },
          { key: "seat", label: "Seat Number", value: value.section4.seat },
          { key: "baggage", label: "Baggage", value: value.section4.baggage },
          { key: "meal", label: "Meal Preferences", value: value.section4.meal },
          { key: "wheelchair", label: "Wheelchair", value: value.section4.wheelchair }
        ])}

        <Divider sx={{ my: 2 }} />

        {/* Section 5 */}
        <Typography sx={{ fontSize: 16, fontWeight: "bold" }}>BAGGAGE AND CARRY-ON ALLOWANCE</Typography>
        <Typography sx={{ fontSize: 15, mt: 1, fontWeight: "bold" }}>Baggage Allowance</Typography>

        {renderCheckboxList("section5.baggageAllowance", [
          { key: "passengerType", label: "Passenger Type", value: value.section5.baggageAllowance.passengerType },
          { key: "origin", label: "Origin/Destination", value: value.section5.baggageAllowance.origin },
          { key: "baggage", label: "Baggage", value: value.section5.baggageAllowance.baggage },
          { key: "information", label: "Information", value: value.section5.baggageAllowance.information }
        ])}

        <Typography sx={{ fontSize: 15, fontWeight: "bold" }}>
          Carry-on Allowance
        </Typography>

        {renderCheckboxList("section5.carryonAllowance", [
          { key: "origin", label: "Origin/Destination", value: value.section5.carryonAllowance.origin },
          { key: "baggage", label: "Baggage", value: value.section5.carryonAllowance.baggage },
          { key: "information", label: "Information", value: value.section5.carryonAllowance.information }
        ])}
      </AccordionDetails>
 
  );
}

ItinerarySettings.propTypes = {
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ItinerarySettings;
